import React, { useState } from "react";

const TestpurposeNw = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [gender, setGender] = useState("male");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [file, setFile] = useState(null);
  const [rangeValue, setRangeValue] = useState(50);
  const [colorValue, setColorValue] = useState("#ff0000");
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [hiddenField] = useState("hiddenValue");
  const [selectValue, setSelectValue] = useState("option1");
  const [multipleSelectValue, setMultipleSelectValue] = useState([]);
  const [textAreaValue, setTextAreaValue] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [urlValue, setUrlValue] = useState("");
  const [telValue, setTelValue] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [timeValue, setTimeValue] = useState("");
  const [weekValue, setWeekValue] = useState("");
  const [monthValue, setMonthValue] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    // Handle form submission logic here
    const formData = {
      firstName,
      lastName,
      dateOfBirth,
      gender,
      email,
      password,
      rememberMe,
      phoneNumber,
      address,
      file,
      rangeValue,
      colorValue,
      checkboxChecked,
      hiddenField,
      selectValue,
      multipleSelectValue,
      textAreaValue,
      searchValue,
      urlValue,
      telValue,
      dateValue,
      timeValue,
      weekValue,
      monthValue,
    };

    console.log(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Second</h3>

      {/* Text Input */}
      <div className="mb-3">
        <label>First Name</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter first name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </div>

      {/* Text Input */}
      <div className="mb-3">
        <label>Last Name</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter last name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </div>

      {/* Date Input */}
      <div className="mb-3">
        <label>Date of Birth</label>
        <input
          type="date"
          className="form-control"
          value={dateOfBirth}
          onChange={(e) => setDateOfBirth(e.target.value)}
        />
      </div>

      {/* Radio Buttons */}
      <div className="mb-3">
        <label>Gender</label>
        <div>
          {/* Radio input options here */}
          <label>
            <input
              type="radio"
              name="gender"
              value="male"
              checked={gender === "male"}
              onChange={() => setGender("male")}
            />
            Male
          </label>
          <label>
            <input
              type="radio"
              name="gender"
              value="female"
              checked={gender === "female"}
              onChange={() => setGender("female")}
            />
            Female
          </label>
          <label>
            <input
              type="radio"
              name="gender"
              value="other"
              checked={gender === "other"}
              onChange={() => setGender("other")}
            />
            Other
          </label>
        </div>
      </div>

      {/* Email Input */}
      <div className="mb-3">
        <label>Email address</label>
        <input
          type="email"
          className="form-control"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      {/* Password Input */}
      <div className="mb-3">
        <label>Password</label>
        <input
          type="password"
          className="form-control"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      {/* Checkbox */}
      <div className="mb-3">
        <div className="custom-control custom-checkbox">
          {/* Checkbox input here */}
          <input
            type="checkbox"
            className="custom-control-input"
            id="customCheck1"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          <label className="custom-control-label" htmlFor="customCheck1">
            Remember me
          </label>
        </div>
      </div>

      {/* Phone Number Input */}
      <div className="mb-3">
        <label>Phone Number</label>
        <input
          type="tel"
          className="form-control"
          placeholder="Enter phone number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      </div>

      {/* Address Textarea */}
      <div className="mb-3">
        <label>Address</label>
        <textarea
          className="form-control"
          placeholder="Enter address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
      </div>

      {/* File Input */}
      <div className="mb-3">
        <label>Upload a File</label>
        {/* File input here */}
        <input
          type="file"
          className="form-control-file"
          onChange={(e) => setFile(e.target.files[0])}
        />
      </div>

      {/* Range Input */}
      <div className="mb-3">
        <label>Range</label>
        {/* Range input here */}
        <input
          type="range"
          className="form-control-range"
          min="0"
          max="100"
          step="1"
          value={rangeValue}
          onChange={(e) => setRangeValue(e.target.value)}
        />
        <p>Value: {rangeValue}</p>
      </div>

      {/* Color Input */}
      <div className="mb-3">
        <label>Color</label>
        {/* Color input here */}
        <input
          type="color"
          className="form-control"
          value={colorValue}
          onChange={(e) => setColorValue(e.target.value)}
        />
      </div>

      {/* Checkbox */}
      <div className="mb-3">
        <div className="custom-control custom-checkbox">
          {/* Checkbox input here */}
          <input
            type="checkbox"
            className="custom-control-input"
            id="customCheck2"
            checked={checkboxChecked}
            onChange={(e) => setCheckboxChecked(e.target.checked)}
          />
          <label className="custom-control-label" htmlFor="customCheck2">
            Check this box
          </label>
        </div>
      </div>

      {/* Hidden Input (for storing values not displayed to the user) */}
      <input type="hidden" name="hiddenField" value={hiddenField} />

      {/* Select Dropdown */}
      <div className="mb-3">
        <label>Select an Option</label>
        <select
          className="form-control"
          value={selectValue}
          onChange={(e) => setSelectValue(e.target.value)}
        >
          {/* Select options here */}
          <option value="option1">Option 1</option>
          <option value="option2">Option 2</option>
          <option value="option3">Option 3</option>
        </select>
      </div>

      {/* Multiple Select */}
      <div className="mb-3">
        <label>Select Multiple Options</label>
        <select
          className="form-control"
          multiple
          value={multipleSelectValue}
          onChange={(e) =>
            setMultipleSelectValue([...e.target.selectedOptions].map((opt) => opt.value))
          }
        >
          {/* Multiple select options here */}
          <option value="option1">Option 1</option>
          <option value="option2">Option 2</option>
          <option value="option3">Option 3</option>
        </select>
      </div>

      {/* Textarea */}
      <div className="mb-3">
        <label>Text Area</label>
        <textarea
          className="form-control"
          placeholder="Enter text"
          value={textAreaValue}
          onChange={(e) => setTextAreaValue(e.target.value)}
        />
      </div>

      {/* Search Input */}
      <div className="mb-3">
        <label>Search</label>
        <input
          type="search"
          className="form-control"
          placeholder="Search here"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>

      {/* URL Input */}
      <div className="mb-3">
        <label>URL</label>
        <input
          type="url"
          className="form-control"
          placeholder="Enter a URL"
          value={urlValue}
          onChange={(e) => setUrlValue(e.target.value)}
        />
      </div>

      {/* Tel Input */}
      <div className="mb-3">
        <label>Telephone</label>
        <input
          type="tel"
          className="form-control"
          placeholder="Enter a telephone number"
          value={telValue}
          onChange={(e) => setTelValue(e.target.value)}
        />
      </div>

      {/* Date Input */}
      <div className="mb-3">
        <label>Date</label>
        <input
          type="date"
          className="form-control"
          value={dateValue}
          onChange={(e) => setDateValue(e.target.value)}
        />
      </div>

      {/* Time Input */}
      <div className="mb-3">
        <label>Time</label>
        <input
          type="time"
          className="form-control"
          value={timeValue}
          onChange={(e) => setTimeValue(e.target.value)}
        />
      </div>

      {/* Week Input */}
      <div className="mb-3">
        <label>Week</label>
        <input
          type="week"
          className="form-control"
          value={weekValue}
          onChange={(e) => setWeekValue(e.target.value)}
        />
      </div>

      {/* Month Input */}
      <div className="mb-3">
        <label>Month</label>
        <input
          type="month"
          className="form-control"
          value={monthValue}
          onChange={(e) => setMonthValue(e.target.value)}
        />
      </div>

      <div className="d-grid">
        <button type="submit" className="btn btn-primary">
          Submit
        </button>
      </div>
    </form>
  );
};

export default TestpurposeNw;
